export default __webpack_public_path__ + "static/media/credit-card.30663839.webp";